module.exports = __webpack_public_path__ + "img/circumstances.bfd078b6.png";